import { useLayoutEffect } from 'react';

export default function useScreenOrientation(
  screenOrientation: string | undefined | null,
  rootElement: HTMLElement,
  logger: Logger,
): void {
  useLayoutEffect(() => {
    if (!screenOrientation) return;

    // The FireTV (Android TV) app does not support portrait so we are using CSS to
    // rotate the root element. This will not work well for interactive apps because
    // it does not rotate touch or other user inputs (keyboard / mouse).
    if (screenOrientation === 'normal') {
      if (rootElement.style.transform) {
        logger.info(`Set screen orientation to normal`);
        rootElement.style.transform = '';
        rootElement.style.transformOrigin = '';
        rootElement.style.width = '';
        rootElement.style.height = '';
      } else {
        logger.info(`Screen orientation is normal, skip setting`);
      }
    } else if (screenOrientation === 'left') {
      logger.info(`Set screen orientation to left`);
      rootElement.style.transform = `rotate(-90deg) translateX(-100vh)`;
      rootElement.style.transformOrigin = 'top left';
      rootElement.style.width = '100vh';
      rootElement.style.height = '100vw';
    } else if (screenOrientation === 'right') {
      logger.info(`Set screen orientation to right`);
      rootElement.style.transform = `rotate(90deg) translateY(-100vw)`;
      rootElement.style.transformOrigin = 'top left';
      rootElement.style.width = '100vh';
      rootElement.style.height = '100vw';
    } else {
      logger.warn(`Invalid screen orientation '${screenOrientation}'`);
    }
  }, [screenOrientation, rootElement, logger]);
}
